import { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withTheme from 'core/hocs/withTheme';
import themePropTypes from 'core/utils/prop-types/theme';
import styles from './index.styl';

function Divider(props) {
  const {
    tag: Component,
    theme,
    className,
    ...restProps
  } = props;

  return (
    <Fragment>
      <style jsx>{`
        .divider
          background-color ${theme.colors.divider}
      `}</style>
      <Component
        {...restProps}
        className={cx(
          'divider',
          styles.divider,
          className,
        )}
      />
    </Fragment>
  );
}

Divider.defaultProps = {
  tag: 'hr',
};

Divider.propTypes = {
  /** Элемент, используемый в качестве разделителя */
  tag: PropTypes.string,

  /** Имя класса для стилизации элемента */
  className: PropTypes.string,

  /** @ignore */
  theme: themePropTypes(`{
    colors: {
      divider,
    }
  }`),
};

const DividerWithHOCs = withTheme(Divider);
DividerWithHOCs.displayName = 'Divider';

export { Divider as StorybookComponent };
export default DividerWithHOCs;
